import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { BaseGenDocTypeService } from '../../erp';
import {GenericDocContainerModel} from "../../../../../../models/aggregates/generic_doc";
import { ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class InternalStockAdjustmentService extends BaseGenDocTypeService {

  readonly url =
  Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-stock-adjustment';

constructor(http: HttpClient) {
  super(http, 'internal-stock-adjustment');
}

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string): Observable<Blob> {
    let params;
    let url;
    if (customParam) {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid)
        .set('customParam', customParam);
    } else {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid);
    }
    url = apiVisa.api_domain_url + this.endpoint_path + '/print-jasper-pdf/' + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  public createTemp(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + '/temp/backoffice-ep',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
